import type { PkRankChange, PkRanks } from "../../types/playerPk";
import "./pk/pk.css";

type Props = {
  rank: keyof PkRanks;
  change: PkRankChange | null;
};

// Arrow next to a rank: how it moved against the previous period of the same
// length. Always renders a fixed-width slot so the ranks stay aligned.
const RankDelta = ({ rank, change }: Props) => {
  const slot = (className: string, text: string, title?: string) => (
    <span className={`rank-delta ${className}`} title={title}>
      {text}
    </span>
  );

  if (!change || !change.previous) return slot("", "");
  const current = change.current.ranks[rank];
  const previous = change.previous.ranks[rank];
  if (current === null && previous === null) return slot("", "");
  if (previous === null) {
    return slot("rank-delta--new", "new", "Not ranked in the previous period");
  }
  if (current === null) {
    return slot(
      "rank-delta--down",
      "out",
      `Was #${previous}, not ranked in this range`
    );
  }
  const moved = previous - current; // lower rank number is better
  if (moved > 0) {
    return slot(
      "rank-delta--up",
      `▲ ${moved}`,
      `Up from #${previous} in the previous period`
    );
  }
  if (moved < 0) {
    return slot(
      "rank-delta--down",
      `▼ ${-moved}`,
      `Down from #${previous} in the previous period`
    );
  }
  return slot("rank-delta--same", "=", `Same as the previous period (#${previous})`);
};

export default RankDelta;
